import {ApiService} from "./api.service";

export class FundService extends ApiService{
  constructor(organizationId) {
    super();
    // this.endpoint = "/funds";
    this.endpoint = `/organizations/${organizationId}/funds`;
  }

  async show(id) {
    return super.show(id);
  }
  async create(params){
    return super.create(params);
  }
  async update(id, params){
    return super.update(id, params);
  }

  async donations(id, params){
    const url = `${this.endpoint}/${id}/donations`;
    return super.get(url, params).then((res) => {
      return res.json;
    });
  }

  async uploadBannerImage(id, file) {
    const formData = new FormData();
    formData.append('fund[banner_image]', file);
    return await this.upload(`${this.endpoint}/${id}/`, formData);
  }

  async removeBannerImage(id) {
    const url = `${this.endpoint}/${id}/remove_banner_image`;
    return await this.post(url);
  }
}
